module.exports = __webpack_public_path__ + "img/app.684656e0.png";